exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-buttons>.btn[data-v-657cbd91]{white-space:nowrap}.action-buttons>.btn[data-v-657cbd91]:not(:first-child){margin-left:.25rem}.action-buttons>.btn[data-v-657cbd91]:not(:last-child){margin-right:.25rem}", ""]);

// exports
